import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Instagram } from "lucide-react";
import LOGO_URL from "../../assets/Logo.png"


const FOOTER_LINKS = [
  {
    title: "Tech & Intelligence",
    items: [
      "Machine Learning",
      "Artificial Intelligence",
      "Data Analytics",
      "Full-Stack Dev",
      "Cloud Infrastructure",
    ],
  },
  {
    title: "Finance & BI",
    items: [
      "Financial Analysis",
      "Business Analysis",
      "Performance Reporting",
      "Forecasting",
    ],
  },
  {
    title: "Graphics & Design",
    items: [
      "Brand Identity",
      "Logo Design",
      "UI/UX Design",
      "Social Media Design",
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-[#030303] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div
              className="flex items-center"
              data-testid="footer-brand"
            >
              <img
                src={LOGO_URL}
                alt="Dataviqu"
                className="h-12 w-auto object-contain"
                draggable={false}
              />
            </div>

            <p className="mt-6 text-zinc-400 text-sm leading-relaxed max-w-sm">
              Dataviqu builds smart data solutions, financial intelligence, and
              stunning visual designs for forward-thinking businesses.
            </p>

            <div className="mt-8">
              <div className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 mb-3">
                Connect with us
              </div>

              <div className="flex gap-3">
                <a
                  href="https://www.linkedin.com/company/dataviqu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/5 hover:border-blue-500/40 transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="w-4 h-4 text-zinc-300" />
                </a>

                <a
                  href="https://www.instagram.com/dataviqu.official?igsh=MTNpamFsaXZxNTY4cw%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram"
                  className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/5 hover:border-blue-500/40 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram className="w-4 h-4 text-zinc-300" />
                </a>
              </div>
            </div>
          </div>

          {/* Footer Columns */}
          {FOOTER_LINKS.map((col) => (
            <div
              key={col.title}
              className="md:col-span-2"
              data-testid={`footer-col-${col.title
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="text-xs font-mono uppercase tracking-[0.25em] text-zinc-500 mb-4">
                {col.title}
              </div>

              <ul className="space-y-2.5">
                {col.items.map((item) => (
                  <li key={item}>
                    <span className="text-sm text-zinc-300 hover:text-white transition-colors cursor-default">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1" />
        </div>

        {/* Bottom Footer */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div
            className="text-xs text-zinc-500"
            data-testid="footer-copyright"
          >
            © 2026 Dataviqu. All Rights Reserved.
          </div>

          <div
            className="flex flex-wrap items-center gap-4 text-sm"
            data-testid="footer-credit"
          >
            <Link
              to="/privacy-policy"
              className="text-zinc-400 hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>

            <span className="text-zinc-600">|</span>

            <Link
              to="/terms-and-conditions"
              className="text-zinc-400 hover:text-white transition-colors"
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}